import { PVFileDurationRef, PVFileFormatRef, PVFileStepRef } from './PVReference';
import assignToThis from '../../helper/assignToThis';
import { ObjectOnly } from '@/classes/ObjectOnly';

export class PVFile {

  public formatRef: PVFileFormatRef | null = null;

  public durationRef: PVFileDurationRef | null = null;

  public stepRef: PVFileStepRef | null = null;

  public startDate: Date | null = null;

  public name: string | null = null;

  public values: number[] | null = null;

  public simulatedPVCapacity: number | null = null;

  public constructor(obj: ObjectOnly = {}) {
    assignToThis(this, obj);

    this.formatRef = this.formatRef ? (PVFileFormatRef as any)[this.formatRef] : null;

    this.durationRef = this.durationRef ? (PVFileDurationRef as any)[this.durationRef] : null;

    this.stepRef = this.stepRef ? (PVFileStepRef as any)[this.stepRef] : null;
  }
}
